import { render, staticRenderFns } from "./ListBarraLateral.vue?vue&type=template&id=505a6cc4"
import script from "./ListBarraLateral.vue?vue&type=script&lang=js"
export * from "./ListBarraLateral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports